import {
  FormProvider,
  SubmitHandler,
  useForm,
  useFormContext,
  UseFormReturn,
} from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { IReviewSummaryReportFormValues } from './types';
import { ReviewSummaryReportSchema } from './validators';

type ReviewSummaryReportFormContext =
  UseFormReturn<IReviewSummaryReportFormValues>;

type ReviewSummaryReportFormSubmission = (
  formUtils: ReviewSummaryReportFormContext
) => SubmitHandler<IReviewSummaryReportFormValues>;

type ReviewSummaryReportProviderProps = {
  children: React.ReactNode;
  onSubmit?: ReviewSummaryReportFormSubmission;
  initialValues?: IReviewSummaryReportFormValues;
};

const useReviewSummaryReportForm = () =>
  useFormContext<IReviewSummaryReportFormValues>();

const defaultFormValues: IReviewSummaryReportFormValues =
  {} as IReviewSummaryReportFormValues;

const ReviewSummaryReportFormProvider = (
  props: ReviewSummaryReportProviderProps
) => {
  const { children, onSubmit, initialValues } = props;

  const formContext = useForm<IReviewSummaryReportFormValues>({
    mode: 'onChange',
    defaultValues: initialValues ?? defaultFormValues,
    resolver: zodResolver(ReviewSummaryReportSchema),
  });

  const handleSubmit = onSubmit
    ? formContext.handleSubmit(onSubmit(formContext))
    : (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
      };

  return (
    <FormProvider {...formContext}>
      <form onSubmit={handleSubmit} style={{ width: '100%' }} noValidate>
        {children}
      </form>
    </FormProvider>
  );
};

export { useReviewSummaryReportForm };
export default ReviewSummaryReportFormProvider;
